import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { root } from './ExamineTree'
import QuizComponent from './QnA';
import { useAlert } from 'react-alert';

const ExamineComponent = () => {
    const QUIZ_COUNT = 8;
    const alert = useAlert();
    const [tree, SetTree] = useState(root) //MBTI 트리노드 구조 
    const [selected, SetSelected] = useState(0) //선택한 value
    const [answer1, SetAnswer1] = useState(false) //답변1 클래스
    const [answer2, SetAnswer2] = useState(false) //답변2 클래스
    const [quiz, SetQuiz] = useState(1) //퀴즈번호

    //답변 클래스 초기화
    const init = () => {
        if (answer1) SetAnswer1(false)
        if (answer2) SetAnswer2(false)
    }

    //답변1,2 버튼 클릭 이벤트
    const handleChoice = (click) => {
        init()
        if (tree.left && tree.left?.value === click) {
            SetAnswer1(true)
            SetSelected(click)
        }

        if (tree.right && tree.right?.value === click) {
            SetAnswer2(true)
            SetSelected(click)
        }
    }

    //다음 버튼 클릭 이벤트
    const handleNext = (choice) => {
        if (choice > 0) {
            if (tree.left?.value === choice) {
                SetTree(tree.left)
            }
            else if (tree.right?.value === choice) {
                SetTree(tree.right)
            }
            SetQuiz(quiz + 1)
            SetSelected(0)
            init()
        }
        else { alert.error('선택되지 않았습니다!') }
    }

    return (
        <div className="mbti-wrapper">
            <div className="part2">
                <div className="progress-area">
                    <span style={{ width: `${12.5 * (quiz)}%` }}></span>
                </div>
                <div className="quiz-box">
                    <QuizComponent
                        tree={tree}
                        quiz_no={quiz}
                        answer1={answer1}
                        answer2={answer2}
                        handleChoice={handleChoice}
                    />
                </div>
                <div className="btn-area">
                    {
                        quiz < QUIZ_COUNT ?
                            <Link
                                to="#"
                                onClick={() => handleNext(selected)}
                                className={`${selected > 0 ? 'on' : ''}`}
                            >다음</Link>
                            :
                            <Link
                                to={`/mbti/result/${selected}`}
                                className={`${selected > 35 ? 'on' : ''}`}
                            >완료</Link>
                    }
                </div>
            </div>
        </div >
    )
}

export default ExamineComponent;